import { useCallback, useEffect, useState } from 'react';

import {
  PassengerRead,
  useLazyPassengersRetrieveQuery,
} from 'src/common/external/bambi-api/bambiApi';

export function useFetchMultiplePassengers(passengerIds: string[]) {
  const [isLoading, setIsLoading] = useState(false);
  const [passengers, setPassengers] = useState<PassengerRead[]>([]);
  const [error, setError] = useState<string | null>(null);

  const [fetchPassenger] = useLazyPassengersRetrieveQuery();

  const fetchAllPassengers = useCallback(async () => {
    setIsLoading(true);

    try {
      const passengers = await Promise.all(
        passengerIds.map((passengerId) =>
          fetchPassenger({ id: passengerId }).unwrap()
        )
      );
      setPassengers(passengers);
    } catch (error) {
      setError(error as string);
    } finally {
      setIsLoading(false);
    }
  }, [fetchPassenger, passengerIds]);

  useEffect(() => {
    if (passengerIds.length === 0) return;

    fetchAllPassengers();
  }, [fetchAllPassengers, passengerIds]);

  return {
    passengers,
    isLoading,
    error,
  };
}
